import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-types',
  templateUrl: './leave-types.component.html'
})
export class LeaveTypesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/leave-types/leave-types.component.ts